import Vue from 'vue'
import Router from 'vue-router'
import VueCookies from 'vue-cookies'
import {
	Message
} from 'element-ui'


Vue.use(Router)

const router = new Router({
	routes: [{
			path: '/login',
			name: 'login',
			component: () => import('@/views/login')
		},
		{
			path: '/',
			// name: 'main',
			component: () => import('@/views/main.vue'),
			children: [{
				path: "/",
				name: 'index',
				meta: {
					title: '首页'
				},
				component: () => import('@/views/index')
			},{
				path:'/user',
				name:'user',
				meta:{
					title:'用户管理'
				},
				component: () => import('@/views/user')
			},{
				path:'/classify',
				name:'classify',
				meta:{
					title:'帮助中心分类'
				},
				component: () => import('@/views/classify')
			},{
				path:'/content',
				name:'content',
				meta:{
					title:'帮助中心'
				},
				component: () => import('@/views/content')
			},{
				path:'/editConent',
				name:'editConent',
				meta:{
					title:'内容修改',
					hidden:true
				},
				component: () => import('@/views/content/edit.vue')
			}]
		}
	]
})

router.beforeEach((to, from, next) => {
	if (to.path == '/login') {
		next()
	} else {
		if (!VueCookies.get('token')) {
			Message({
				message: '账号未登录',
				type: 'error',
				duration: 5 * 1000
			})
			next('/login')
		} else {
			next()
		}
	}
})

export default router
